<template>
  <nav v-if="category" :class="$style['category-navigation']">
    <div
      :class="$style['category-navigation__title']">
      <h1 v-if="!parent" :class="$style['category-navigation__heading']">
        {{ category.title }}
      </h1>
      <div v-else :class="$style['category-navigation__title__breadcrumbs']">
        <NuxtLink
          :class="$style['category-navigation__heading']"
          exact
          :to="{
            path: '/' + $lang + '/' + parent.slug
          }">
          {{ parent.title }}
        </NuxtLink>
        <span v-if="parent" :class="$style['category-navigation__heading']">&nbsp;/&nbsp;</span>
        <h1 :class="$style['category-navigation__heading']">
          {{ category.title }}
        </h1>
      </div>

      <div :class="$style['category-navigation__title__actions']">
        <Btn
          v-if="category.action !== 'collections'"
          compact
          color="white"
          class="h-hide-tablet-up"
          aria-label="Toggle filters"
          @click.prevent="rootStore.filtersOpen = true">
          <SvgIcon name="System/filter-line" />
        </Btn>
      </div>
    </div>
  </nav>
</template>
<script setup>
const rootStore = useRootStore()

defineProps({
  category: {
    type: [Object, Array, Boolean],
    default: null
  },
  parent: {
    type: [Object, Array, Boolean],
    default: null
  }
})
</script>
<style lang="scss" module>
.category-navigation {
  display: flex;
  width: 100%;
  background-color: $broken-white;
  padding: $spacing * 2;

  @media (max-width: #{$breakpoint-tablet}) {
    background-color: $white;
    height: var(--toolbar-height);
  }

  &__heading {
    display: inline-flex;
    align-items: center;
    height: 100%;
    font-size: $font-size-xxl;
    font-family: $font-heading;
    font-weight: $font-weight-heading;

    @media (max-width: #{$breakpoint-tablet}) {
      font-size: $font-size-l;
      line-height: $line-height;
    }
  }

  &__title {
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: 100%;

    &__breadcrumbs {
        align-items: center;
        justify-content: center;
        display: inline-flex;
        line-height: 1;
    }

    &__actions {
      display: flex;

      @media (min-width: #{$breakpoint-tablet}) {
        display: none;
      }
    }
  }
}
</style>
